/**
 * pdf上报表名
 */
export const PDF_TABLE = 'liebao_vip_pdf:522 source:byte page_show:byte click:byte'
/**
 * 打开来源
 * @readonly
 * @enum {Number}
 */
export const OPEN_FORM = {
  /**
   * 收藏夹
   */
  COLLECT: 1,
  /**
   * 右上角引流泡
   */
  TOP_RIGHT_HEAD: 2,
  /**
   * 下载完成后tips
   */
  DOWNLOAD_TIPS: 3,
  /**
   * 自带PDF阅读器挂件
   */
  BROWSER_PDF: 4,
  /**
   * 会员落地页
   */
  VIP: 5,
  /**
   * 侧边栏
   */
  SIDE_BAR: 133
}

/**
 * pdf功能页
 * @readonly
 * @enum {Number}
 */
export const PDF_PAGE = {
  /**
   * 首页
   */
  HOME: 1,
  /**
   * pdf 转 word
   */
  PDF_2_WORD: 2,
  /**
   * pdf 转 图片
   */
  PDF_2_IMAGE: 3,
  /**
   * pdf 转 ppt
   */
  PDF_2_PPT: 4,
  /**
   * pdf 转 excel
   */
  PDF_2_EXCEL: 5,
  /**
   * pdf 转 txt
   */
  PDF_2_TXT: 6,
  /**
   * word 转 pdf
   */
  WORD_2_PDF: 7,
  /**
   * 图片 转 pdf
   */
  IMAGE_2_PDF: 8,
  /**
   * ppt 转 pdf
   */
  PPT_2_PDF: 9,
  /**
   * excel 转 pdf
   */
  EXCEL_2_PDF: 10,
  /**
   * pdf 转 cad
   */
  PDF_2_CAD: 11,
  /**
   * cad 转 pdf
   */
  CAD_2_PDF: 12,
  /**
   * 开通VIP弹框
   */
  VIP_DIALOG: 13,
  /**
   * 用户登录弹框
   */
  LOGIN_DIALOG: 14
}

/**
 * 页面动作
 * @readonly
 * @enum {Number}
 */
export const PAGE_ACTION = {
  /**
   * 默认
   */
  DEFAULT: 0,
  /**
   * 点击开通vip按钮
   */
  OPEN_VIP: 1,
  /**
   * 点击登录
   */
  LOGIN: 2,
  /**
   * 点击上传文件
   */
  UPLOAD: 3,
  /**
   * 拖拽文件
   */
  DRAG: 4,
  /**
   * 点击开始转换按钮
   */
  CONVERT: 5,
  /**
   * 点击下载按钮
   */
  DOWNLOAD: 6
}
